export default class LastWeekUsers {
  constructor() {
    if (this.vars()) {
      this.initChart();
    }
  }

  vars() {
    this.ctx = document.getElementById('adminUsersWeekly');

    if (!this.ctx) return;

    this.chart = null;
    this.labels = JSON.parse(this.ctx.getAttribute('data-labels'));
    this.valuesTotal = JSON.parse(this.ctx.getAttribute('data-values-total'));
    this.valuesInactive = JSON.parse(this.ctx.getAttribute('data-values-inactive'));
    this.valuesReturned = JSON.parse(this.ctx.getAttribute('data-values-returned'));
    return true;
  }

  initChart() {
    this.chart = new Chart(this.ctx, {
        type: 'line',
        data: {
          labels: this.labels,
          datasets: [
            {
              label: '# użytkowników',
              data: this.valuesTotal,
              backgroundColor: 'rgba(54, 162, 235, 0.2)',
              borderColor: 'rgba(54, 162, 235, 1)',
              borderWidth: 1
            },
            {
              label: '# nieaktywnych',
              data: this.valuesInactive,
              backgroundColor: 'rgba(244, 66, 95, 0)',
              borderColor: 'rgba(244, 66, 95, 1)',
              borderWidth: 1
            },
            {
              label: '# powracających',
              data: this.valuesReturned,
              backgroundColor: 'rgba(66, 219, 15, 0)',
              borderColor: 'rgba(66, 219, 15, 1)',
              borderWidth: 1
            }
          ]
        },
    });
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/Charts/LastWeekUsers.js